export default {
  login: 'BoomBoomRay',
  id: 50201713,
  node_id: 'MDQ6VXNlcjUwMjAxNzEz',
  avatar_url: 'https://avatars0.githubusercontent.com/u/50201713?v=4',
  gravatar_id: '',
  url: 'https://api.github.com/users/BoomBoomRay',
  html_url: 'https://github.com/BoomBoomRay',
  followers_url: 'https://api.github.com/users/BoomBoomRay/followers',
  following_url:
    'https://api.github.com/users/BoomBoomRay/following{/other_user}',
  gists_url: 'https://api.github.com/users/BoomBoomRay/gists{/gist_id}',
  starred_url:
    'https://api.github.com/users/BoomBoomRay/starred{/owner}{/repo}',
  subscriptions_url: 'https://api.github.com/users/BoomBoomRay/subscriptions',
  organizations_url: 'https://api.github.com/users/BoomBoomRay/orgs',
  repos_url: 'https://api.github.com/users/BoomBoomRay/repos',
  events_url: 'https://api.github.com/users/BoomBoomRay/events{/privacy}',
  received_events_url:
    'https://api.github.com/users/BoomBoomRay/received_events',
  type: 'User',
  site_admin: false,
  name: 'Ray Romero',
  company: null,
  blog: 'www.raymondchinoromero.com',
  location: null,
  email: null,
  hireable: null,
  bio: 'Aspiring software engineer',
  twitter_username: 'RayRomero',
  public_repos: 5,
  public_gists: 0,
  followers: 2,
  following: 4,
  created_at: '2019-05-02T11:14:52Z',
  updated_at: '2021-01-07T03:39:58Z',
};
